/* eslint-disable import/prefer-default-export */

export const error = {
  additionalFuture: {
    title: 'There is a problem with the date range',
    message:
      'For the additional employment date range, the dates should be before the main entries from date.',
    note: '',
  },
  beforeHired: {
    title: 'There is a problem with the date provided',
    message: 'This incident cannot have happened before you were hired. Please check the dates provided.',
    note: '',
  },
  applicantMin: {
    title: 'There is a problem with the date',
    message: 'This date is before you were born.',
  },
  beforeDuration: {
    title: 'There is a problem with the date',
    message: 'This date occurred longer ago than required. Please check that the dates entered are correct.',
  },
  afterDuration: {
    title: 'There is a problem with the date',
    message: 'This date is more recent than required',
  },
  toggleablelocation: {
    required: {
      title: 'Your response is required',
      message: '',
    },
  },
  inclusion: {
    title: 'The selected option does not exist',
    message: '',
    note: '',
  },
  invalidNumber: {
    title: 'Invalid format',
    message: 'Please use numbers only',
    note: '',
  },
  minimumLength: {
    title: 'Too short',
    message: 'You have not entered the minimum number of characters for this field.',
    note: '',
  },
  maximumLength: {
    title: 'Too long',
    message: 'You have too many characters for this field.',
    note: '',
  },
  list: {
    duplicate: {
      title: 'Oops, there\'s a problem.',
      message: 'You have at least one duplicated item in the list. Please correct or remove the duplicate item.',
      note: '',
    },
    length: {
      min: {
        title: 'Oops, there\'s a problem.',
        message: 'You must have at least one item.',
        note: '',
      },
      citizenshipMin: {
        title: 'There is a problem with your entry',
        message: 'Please provide a minimum of two countries.',
        note: '',
      },
      relationshipsPeople: {
        title: 'Coverage gap',
        message: 'List at least 3 people who know you well.',
        note: '',
      },
    },
  },
  gap: {
    historyResidence: {
      title: 'Residence gap',
      message:
        'There is a gap in your residence history. The entire {{years}} year period must be covered with no gaps.\n{{gaps}}',
    },
    historyEmployment: {
      title: 'Employment gap',
      message:
        'There is a gap in your employment history. The entire {{years}} year period must be covered with no gaps.\n{{gaps}}',
    },
    relationshipsPeople: {
      title: 'Coverage gap',
      message:
        'There is a gap in your coverage. The entire {{years}} years should be covered with no gaps.\n{{gaps}}',
    },
  },
  presentUnchecked: {
    historyResidence: {
      title: 'There is a problem with the date coverage.',
      message: 'You need to have at least one "present" checkbox selected to indicate your current residence.',
    },
    historyEmployment: {
      title: 'There is a problem with the date coverage.',
      message: 'You need to have at least one "present" checkbox selected to indicate your current employment status.',
    },
    relationshipsPeople: {
      title: 'There is a problem with the date coverage.',
      message: 'You need to have at least one "present" checkbox selected to indicate someone who currently knows you well.',
    }
  },
  name: {
    last: {
      required: {
        title: 'Oops, there\'s a problem.',
        message: 'The last name must be provided.',
        note: '',
      },
      length: {
        title: 'Oops, there\'s a problem.',
        message: '',
        note: '',
      },
      pattern: {
        title: 'There is a problem with the last name',
        message: "Some of these characters aren't allowed.",
        note: "Only use letters, hyphens (-), periods (.), apostrophes ('), and spaces.",
      },
      dataIntegrity: {
        checkedWithValue: {
          title: 'Oops, there\'s a problem.',
          message:
            'Conflicting data found. Please correct by clearing Last Name field',
          note: '',
        },
      },
    },
    first: {
      required: {
        title: 'Oops, there\'s a problem.',
        message:
          'If this first name is a single letter, please select the "Initial only" checkbox and type the letter.',
        note: '',
      },
      length: {
        title: 'Oops, there\'s a problem.',
        message:
          'If this first name is a single letter, please select the "Initial only" checkbox and type the letter.',
        note: '',
        tooshort: {
          title: 'Oops, there\'s a problem.',
          message:
          'If this first name is a single letter, please select the "Initial only" checkbox and type the letter.',
          note: '',
        },
        tooshortPvq: {
          title: 'Oops, there\'s a problem.',
          message:
          'If this middle name is a single letter, please select the "Letter(s) only" checkbox and type the letter.',
          note: '',
        },
        toolong: {
          title: 'Oops, there\'s a problem.',
          message:
            'You\'ve checked the "initial only" checkbox, but entered more than one character. Please only enter a single character or un-check the "initial only" checkbox.',
          note: '',
        },
      },
      pattern: {
        title: 'There is a problem with the first name',
        message: "Some of these characters aren't allowed.",
        note: "Only use letters, hyphens (-), periods (.), apostrophes ('), and spaces.",
      },
      dataIntegrity: {
        checkedWithValue: {
          title: 'Oops, there\'s a problem.',
          message:
            "Conflicting data found. Please correct by unselecting 'No First Name' or clearing First Name field",
          note: '',
        },
      },
    },
    middle: {
      required: {
        title: 'Oops, there\'s a problem.',
        message:
          'If this middle name is a single letter, please select the "Initial only" checkbox and type the letter.',
        note: '',
      },
      length: {
        title: 'Oops, there\'s a problem.',
        message:
          'If this middle name is a single letter, please select the "Initial only" checkbox and type the letter.',
        note: '',
        empty: {
          title: 'Oops, there\'s a problem.',
          message: 'Middle name must be empty',
          note: '',
        },
        tooshort: {
          title: 'Oops, there\'s a problem.',
          message:
          'If this middle name is a single letter, please select the "Initial only" checkbox and type the letter.',
          note: '',
        },
        tooshortPvq: {
          title: 'Oops, there\'s a problem.',
          message:
          'If this middle name is a single letter, please select the "Letter(s) only" checkbox and type the letter.',
          note: '',
        },
        toolong: {
          title: 'Oops, there\'s a problem.',
          message:
            'You\'ve checked the "Initial only" checkbox, but entered more than one character. Please only enter a single character or un-check the "Initial only" checkbox.',
          note: '',
        },
      },
      pattern: {
        title: 'There is a problem with the middle name',
        message: "Some of these characters aren't allowed.",
        note: "Only use letters, hyphens (-), periods (.), apostrophes ('), and spaces.",
      },
      dataIntegrity: {
        checkedWithValue: {
          title: 'Oops, there\'s a problem.',
          message:
            "Conflicting data found. Please correct by unselecting 'No Middle Name' or clearing Middle Name field",
          note: '',
        },
      },
    },
    suffix: {
      required: {
        title: 'Your response is required',
        message: '',
        note: '',
      },
      inclusion: {
        title: 'The selected option does not exist',
        message: '',
        note: '',
      },
    },
    suffixOther: {
      pattern: {
        title: 'There is a problem with the name suffix',
        message: "Some of these characters aren't allowed.",
        note: "Only use letters, hyphens (-), periods (.), apostrophes ('), and commas (,) and spaces.",
      },
      length: {
        toolong: {
          title: 'Oops, there\'s a problem.',
          message:
            'The suffix is too long',
          note: '',
        },
      },
    },
    initialonly: {
      length: {
        title: 'Oops, there\'s a problem.',
        message: '"Initial only" is selected. Initial can only be one letter.',
        note: '',
      },
      pattern: {
        title: 'Oops, there\'s a problem.',
        message: "Some of these characters aren't allowed.",
        note: 'Only use letters or unselect "Intial only."',
      },
    },
    duplicate: {
      alias: {
        title: 'Oops, there\'s a problem.',
        message: 'This alias is a duplicate of another alias, correct or remove the duplicate.',
        note: '',
      },
    },
    required: {
      title: 'Your response is required',
      message: '',
      note: '',
    },
  },
  birthdate: {
    age: {
      title: 'The applicant age is not approved',
      message: [
        'Your date of birth indicates you are under the age of 16 or over 100.',
        'Please confirm the date is correct by checking the box below.',
      ],
      note: '',
      min: {
        title: 'The applicant age is not approved',
        message: [
          'Your date of birth indicates you are over the age of 100. Please contact your security office representative or the individual who initiated your investigation regarding further instruction.',
        ],
        note: '',
      },
      max: {
        title: 'The applicant age is not approved',
        message: [
          'Your date of birth indicates you are under the age of 16.',
          'Please confirm the date is correct by checking the box below.',
        ],
        note: '',
      },
      future: {
        title: 'The applicant age is not approved',
        message: 'Your date of birth cannot be in the future.',
        note: '',
      },
    },
  },
  ssn: {
    duplicate: {
      applicantMarital: {
        exclusion: {
          title: 'This Social Security Number is a duplicate of another you have entered.',
          message: 'You have entered duplicate Social Security Numbers for yourself and your spouse. Please enter a unique Social Security Number.',
          note: '',
        },
      },
      applicantCohabitant: {
        exclusion: {
          title: 'This Social Security Number is a duplicate of another you have entered.',
          message: 'You have entered duplicate Social Security Numbers for yourself and a cohabitant. Please enter a unique Social Security Number.',
          note: '',
        },
      },
      maritalCohabitant: {
        exclusion: {
          title: 'This Social Security Number is a duplicate of another you have entered.',
          message: 'You have entered duplicate Social Security Numbers for your spouse and a cohabitant. Please enter a unique Social Security Number.',
          note: '',
        },
      },
      applicantMaritalCohabitant: {
        exclusion: {
          title: 'This Social Security Number is a duplicate of another you have entered.',
          message: 'You have entered duplicate Social Security Numbers for yourself, your spouse, and a cohabitant. Please enter a unique Social Security Number.',
          note: '',
        },
      },
      cohabitants: {
        exclusion: {
          title: 'This Social Security Number is a duplicate of another you have entered.',
          message: 'You have entered duplicate Social Security Numbers for two or more cohabitants. Please enter a unique Social Security Number.',
          note: '',
        },
      },
      defaultMessage: {
        exclusion: {
          title: 'This Social Security Number is a duplicate of another you have entered.',
          message: 'Please enter a unique Social Security Number.',
          note: '',
        },
      },
    },
    first: {
      minimum: {
        title: 'This field must have 3 digits',
        message: 'The first part of the Social Security Number must be 3 digits between 0 and 9',
        note: '',
      },
      pattern: {
        title: 'Please enter a valid Social Security Number.',
        note: '',
      },
    },
    middle: {
      pattern: {
        title: 'This field must have 2 digits',
        message: 'The middle part of the Social Security Number must be 2 digits between 0 and 9',
        note: '',
      },
    },
    last: {
      pattern: {
        title: 'This field must have 4 digits',
        message: 'The last part of the Social Security Number must be 4 digits between 0 and 9',
        note: '',
      },
    },
    mismatch: {
      title: 'Confirmation mismatch',
      message: 'The two U.S. Social Security Numbers you entered do not match.',
      note: '',
    },
    required: {
      title: 'Your response is required',
      message: '',
      note: '',
    },
    invalid: {
      title: 'Invalid Social Security Number',
      message: 'The Social Security Number is considered invalid.',
      note: '',
    },
  },
  selective: {
    pattern: {
      title: 'Oops, there\'s a problem.',
      message: 'Your Selective Service Number should only be numbers and hyphens.',
      note: '',
    },
    required: {
      title: 'Your response is required',
      message: 'Your Selective Service Number is required.',
      note: '',
    },
  },
  additionalActivity: {
    invalidType: {
      title: 'There is a problem with Additional Periods of Activity',
      message: 'Additional periods of activity are not allowed on employment items of type "Unemployment" or "Self-Employment".',
    },
    to: {
      month: {
        notfound: {
          title: 'There is a problem with the Month',
          message: 'The month should be between 01 (January) and 12 (December).',
          note: '',
        },
        min: {
          title: 'There is a problem with the Month',
          message: 'The month should be between 01 (January) and 12 (December).',
          note: '',
        },
        max: {
          title: 'There is a problem with the Month',
          message: 'The month should be between 01 (January) and 12 (December).',
          note: '',
        },
      },
      day: {
        length: {
          title: 'There is a problem with the Day',
          message: 'There is not that many days in this month.',
          note: '',
        },
        min: {
          title: 'There is a problem with the Day',
          message: 'There are not that many days in this month.',
          note: '',
        },
        max: {
          title: 'There is a problem with the Day',
          message: 'There are not that many days in this month.',
          note: '',
        },
      },
      year: {
        max: {
          title: 'There is a problem with the date',
          message:
            "For the **additional employment** date range, the dates should be before the main entry's **from** date.",
          note: '',
        },
        min: {
          title: 'There is a problem with the Year',
          message: 'This year is too far in the past.',
          note: '',
        },
      },
      max: {
        title: 'There is a problem with the date',
        message:
          "For the **additional employment** date range, the dates should be before the main entry's **from** date.",
      },
      min: {
        title: 'There is a problem with the date',
        message: 'The date should be after your date of birth.',
      },
      required: {
        title: 'Your response is required',
        message: 'All parts of the date are required even if it is **estimated**.',
      },
    },
    from: {
      month: {
        notfound: {
          title: 'There is a problem with the Month',
          message: 'The month should be between 01 (January) and 12 (December).',
          note: '',
        },
        min: {
          title: 'There is a problem with the Month',
          message: 'The month should be between 01 (January) and 12 (December).',
          note: '',
        },
        max: {
          title: 'There is a problem with the Month',
          message: 'The month should be between 01 (January) and 12 (December).',
          note: '',
        },
      },
      day: {
        length: {
          title: 'There is a problem with the Day',
          message: 'There is not that many days in this month.',
          note: '',
        },
        min: {
          title: 'There is a problem with the Day',
          message: 'There are not that many days in this month.',
          note: '',
        },
        max: {
          title: 'There is a problem with the Day',
          message: 'There are not that many days in this month.',
          note: '',
        },
      },
      year: {
        max: {
          title: 'There is a problem with the date',
          message:
            "For the **additional employment** date range, the dates should be before the main entry's **from** date.",
          note: '',
        },
        min: {
          title: 'There is a problem with the Year',
          message: 'This year is too far in the past.',
          note: '',
        },
      },
      max: {
        title: 'There is a problem with the date',
        message:
          "For the **additional employment** date range, the dates should be before the main entry's **from** date.",
      },
      min: {
        title: 'There is a problem with the date',
        message: 'The date should be after your date of birth.',
      },
      required: {
        title: 'Your response is required',
        message: 'All parts of the date are required even if it is **estimated**.',
      },
    },
  },
  date: {
    month: {
      notfound: {
        title: 'There is a problem with the Month',
        message: 'The month should be between 01 (January) and 12 (December).',
        note: '',
      },
      min: {
        title: 'There is a problem with the Month',
        message: 'The month should be between 01 (January) and 12 (December).',
        note: '',
      },
      max: {
        title: 'There is a problem with the Month',
        message: 'The month should be between 01 (January) and 12 (December).',
        note: '',
      },
    },
    day: {
      length: {
        title: 'There is a problem with the Day',
        message: 'There is not that many days in this month.',
        note: '',
      },
      min: {
        title: 'There is a problem with the Day',
        message: 'There are not that many days in this month.',
        note: '',
      },
      max: {
        title: 'There is a problem with the Day',
        message: 'There are not that many days in this month.',
        note: '',
      },
    },
    year: {
      max: {
        title: 'There is a problem with the Year',
        message: "The year can't be in the future.",
        note: '',
      },
      min: {
        title: 'There is a problem with the Year',
        message: 'This year is too far in the past.',
        note: '',
      },
      occurred: {
        max: {
          title: 'There is a problem with the Year',
          message: "The year can't be after the dates of involvement or use to year.",
          note: '',
        },
        min: {
          title: 'There is a problem with the Year',
          message: "The year can't be before the dates of involvement or use to year.",
          note: '',
        },
      },
    },
    max: {
      title: 'There is a problem with the date',
      message: "The date can't be in the future.",
      note: '',
    },
    min: {
      title: 'There is a problem with the date',
      message: 'The date should be after your date of birth.',
      note: '',
    },
    invalid: {
      title: 'There is a problem with the date',
      message: 'The date is not valid.',
      note: '',
    },
    required: {
      title: 'Your response is required',
      message: 'All parts of the date are required even if it is **estimated**.',
      note: '',
    },
    past: {
      title: 'There is a problem with the date',
      message: "The date can't be in the past.",
      note: '',
    },
    bankruptcyDischargeDateTooEarly: {
      title: 'There is a problem with the date',
      message: 'The discharge date should be after the bankruptcy filing date.',
      note: '',
    },
    endDateTooEarly: {
      title: 'There is a problem with the date',
      message: 'The end date should be after the begin date.',
      note: '',
    },
    relinquishedDateTooEarly: {
      title: 'There is a problem with the date',
      message: 'The date should be after the acquired date.',
      note: '',
    },
    soldDateTooEarly: {
      title: 'There is a problem with the date',
      message: 'The date should be after the acquired date.',
      note: '',
    },
    lastContactDateTooEarly: {
      title: 'There is a problem with the date',
      message: 'The date should be after the first contact date.',
      note: '',
    },
    lastContactDateTooEarlyResidence: {
      title: 'There is a problem with the date',
      message: 'The date should be on or after the residence start date.',
      note: '',
    },
    financialDelinquencyResolvedDateTooEarly: {
      title: 'There is a problem with the date',
      message: 'The date should be after the date the financial issue began.',
      note: '',
    },
    clearanceGrantedDateTooEarly: {
      title: 'There is a problem with the date',
      message: 'The date the clearance was granted has to be after the date the Investigation was completed.',
      note: '',
    },
    sponsoredForeignNationalDateTooEarly: {
      title: 'There is a problem with the date',
      message: "The date should be after the sponsored foreign national's birth date.",
      note: '',
    },
    notWithinSevenYears: {
      title: 'There is a problem with the date',
      message: 'The date must be within the past seven years.',
      note: '',
    },
    oldestSelectedBirthdate: {
      title: 'There is a problem with the date',
      message: 'The date should be after the date of birth of the oldest person selected above.',
      note: '',
    },
    relativeBirthdate: {
      title: 'There is a problem with the date',
      message: "The date should be after the relative's birth date.",
      note: '',
    },
    acceptedDateTooEarly: {
      title: 'There is a problem with the date',
      message: 'The date should be after the offer or request date.',
      note: '',
    },
    performedDateTooEarly: {
      title: 'There is a problem with the date',
      message: 'The date should be after the accepted date.',
      note: '',
    },
    returnToWorkTooEarly: {
      title: 'There is a problem with the date',
      message: 'Return to work date cannot be before last day of previous employment',
      note: '',
    },
  },
  relative: {
    month: {
      notfound: {
        title: 'There is a problem with the Month',
        message: 'The month should be between 01 (January) and 12 (December).',
        note: '',
      },
      min: {
        title: 'There is a problem with the Month',
        message: 'The month should be between 01 (January) and 12 (December).',
        note: '',
      },
      max: {
        title: 'There is a problem with the Month',
        message: 'The month should be between 01 (January) and 12 (December).',
        note: '',
      },
    },
    day: {
      length: {
        title: 'There is a problem with the Day',
        message: 'There is not that many days in this month.',
        note: '',
      },
      min: {
        title: 'There is a problem with the Day',
        message: 'There are not that many days in this month.',
        note: '',
      },
      max: {
        title: 'There is a problem with the Day',
        message: 'There are not that many days in this month.',
        note: '',
      },
    },
    year: {
      max: {
        title: 'There is a problem with the Year',
        message: "The year can't be in the future.",
        note: '',
      },
      min: {
        title: 'There is a problem with the Year',
        message: 'This year is too far in the past.',
        note: '',
      },
    },
    max: {
      title: 'There is a problem with the date',
      message: "The date can't be in the future.",
    },
    min: {
      title: 'There is a problem with the date',
      message: 'This date is before either you or your relative was born.',
    },
    required: {
      title: 'Your response is required',
      message: 'All parts of the date are required even if it is **estimated**.',
    },
    parent: {
      max: {
        title: 'There is a problem with the date.',
        message: 'This date cannot be after your birthdate.',
      },
    },
    inlaw: {
      title: 'There is a problem with the relative type.',
      message: 'If you select "never been married" you can not select "in-law" as a relative type.',
    },
    duplicateAlias: {
      title: 'There is a problem with a relative\'s other names.',
      message: 'You have at least one duplicated other name among your relatives; this could be a maiden name, nickname, alias, or former name. Please correct or remove the duplicate item.',
      note: '',
    },
  },
  daterange: {
    tooShort: {
      title: 'There is a problem with the date range',
      message: 'The selected date range is too short.',
      note: '',
    },
    tooLong: {
      title: 'There is a problem with the date range',
      message: 'The selected date range is too long.',
      note: '',
    },
    to: {
      month: {
        notfound: {
          title: 'There is a problem with the Month',
          message: 'For the **to** date, the month should be between 1(January) and 12(December).',
          note: '',
        },
        min: {
          title: 'There is a problem with the Month',
          message: 'For the **to** date, the month should be between 1(January) and 12(December).',
          note: '',
        },
        max: {
          title: 'There is a problem with the Month',
          message: 'For the **to** date, the month should be between 1(January) and 12(December).',
          note: '',
        },
      },
      day: {
        length: {
          title: 'There is a problem with the Day',
          message: 'For the **to** date, there are not that many days in this month.',
          note: '',
        },
        min: {
          title: 'There is a problem with the Day',
          message: 'For the **to** date, there are not that many days in this month.',
          note: '',
        },
        max: {
          title: 'There is a problem with the Day',
          message: 'For the **to** date, there are not that many days in this month.',
          note: '',
        },
      },
      year: {
        max: {
          title: 'There is a problem with the Year',
          message: "For the **to** date, the year can't be in the future.",
          note: '',
        },
        min: {
          title: 'There is a problem with the Year',
          message: 'For the **to** date, this year is too far in the past.',
          note: '',
        },
      },
      max: {
        title: 'There is a problem with the date',
        message: "For the **to** date, the date can't be in the future.",
      },
      min: {
        title: 'There is a problem with the date',
        message: 'For the **to** date, the date should be after your date of birth.',
      },
      relative: {
        month: {
          notfound: {
            title: 'There is a problem with the Month',
            message:
              'For the **to** date, the month should be between 1(January) and 12(December).',
            note: '',
          },
          min: {
            title: 'There is a problem with the Month',
            message:
              'For the **to** date, the month should be between 1(January) and 12(December).',
            note: '',
          },
          max: {
            title: 'There is a problem with the Month',
            message:
              'For the **to** date, the month should be between 1(January) and 12(December).',
            note: '',
          },
        },
        day: {
          length: {
            title: 'There is a problem with the Day',
            message: 'For the **to** date, there are not that many days in this month.',
            note: '',
          },
          min: {
            title: 'There is a problem with the Day',
            message: 'For the **to** date, there are not that many days in this month.',
            note: '',
          },
          max: {
            title: 'There is a problem with the Day',
            message: 'For the **to** date, there are not that many days in this month.',
            note: '',
          },
        },
        year: {
          max: {
            title: 'There is a problem with the Year',
            message: "For the **to** date, the year can't be in the future.",
            note: '',
          },
          min: {
            title: 'There is a problem with the Year',
            message: 'For the **to** date, this year is too far in the past.',
            note: '',
          },
        },
        max: {
          title: 'There is a problem with the date',
          message: "For the **to** date, the date can't be in the future.",
        },
        min: {
          title: 'There is a problem with the date',
          message: "For the **to** date, the date should be after this person's date of birth.",
        },
      },
      cohabitant: {
        month: {
          notfound: {
            title: 'There is a problem with the Month',
            message:
              'For the **to** date, the month should be between 1(January) and 12(December).',
            note: '',
          },
          min: {
            title: 'There is a problem with the Month',
            message:
              'For the **to** date, the month should be between 1(January) and 12(December).',
            note: '',
          },
          max: {
            title: 'There is a problem with the Month',
            message:
              'For the **to** date, the month should be between 1(January) and 12(December).',
            note: '',
          },
        },
        day: {
          length: {
            title: 'There is a problem with the Day',
            message: 'For the **to** date, there are not that many days in this month.',
            note: '',
          },
          min: {
            title: 'There is a problem with the Day',
            message: 'For the **to** date, there are not that many days in this month.',
            note: '',
          },
          max: {
            title: 'There is a problem with the Day',
            message: 'For the **to** date, there are not that many days in this month.',
            note: '',
          },
        },
        year: {
          max: {
            title: 'There is a problem with the Year',
            message: "For the **to** date, the year can't be in the future.",
            note: '',
          },
          min: {
            title: 'There is a problem with the Year',
            message: 'For the **to** date, this year is too far in the past.',
            note: '',
          },
        },
        max: {
          title: 'There is a problem with the date',
          message: "For the **to** date, the date can't be in the future.",
        },
        min: {
          title: 'There is a problem with the date',
          message: "For the **to** date, the date should be after this person's date of birth.",
        },
        duplicateAlias: {
          title: 'There is a problem with a cohabitant\'s other names.',
          message: 'You have at least one duplicated other name among your cohabitants; this could be a maiden name, nickname, alias, or former name. Please correct or remove the duplicate item.',
          note: '',
        },
      },
      civilunion: {
        month: {
          notfound: {
            title: 'There is a problem with the Month',
            message:
              'For the **to** date, the month should be between 1(January) and 12(December).',
            note: '',
          },
          min: {
            title: 'There is a problem with the Month',
            message:
              'For the **to** date, the month should be between 1(January) and 12(December).',
            note: '',
          },
          max: {
            title: 'There is a problem with the Month',
            message:
              'For the **to** date, the month should be between 1(January) and 12(December).',
            note: '',
          },
        },
        day: {
          length: {
            title: 'There is a problem with the Day',
            message: 'For the **to** date, there are not that many days in this month.',
            note: '',
          },
          min: {
            title: 'There is a problem with the Day',
            message: 'For the **to** date, there are not that many days in this month.',
            note: '',
          },
          max: {
            title: 'There is a problem with the Day',
            message: 'For the **to** date, there are not that many days in this month.',
            note: '',
          },
        },
        year: {
          max: {
            title: 'There is a problem with the Year',
            message: "For the **to** date, the year can't be in the future.",
            note: '',
          },
          min: {
            title: 'There is a problem with the Year',
            message: 'For the **to** date, this year is too far in the past.',
            note: '',
          },
        },
        max: {
          title: 'There is a problem with the date',
          message: "For the **to** date, the date can't be in the future.",
        },
        min: {
          title: 'There is a problem with the date',
          message: "For the **to** date, the date should be after this person's date of birth.",
        },
        duplicateAlias: {
          title: 'There is a problem with a spouse/partner\'s other names.',
          message: 'You have at least one duplicated other name among your spouse/partner\'s other names; this could be a maiden name, nickname, alias, or former name. Please correct or remove the duplicate item.',
          note: '',
        },
      },
      foreignNationalSponsorship: {
        max: {
          title: 'There is a problem with your entry',
          message: 'For the **to** date, the date cannot occur after the present day.',
        },
        min: {
          title: 'There is a problem with your entry',
          message: "For the **to** date, the date should be after this person's date of birth.",
        },
      },
    },
    from: {
      month: {
        notfound: {
          title: 'There is a problem with the Month',
          message:
            'For the **from** date, the month should be between 1(January) and 12(December).',
          note: '',
        },
        min: {
          title: 'There is a problem with the Month',
          message:
            'For the **from** date, the month should be between 1(January) and 12(December).',
          note: '',
        },
        max: {
          title: 'There is a problem with the Month',
          message:
            'For the **from** date, the month should be between 1(January) and 12(December).',
          note: '',
        },
      },
      day: {
        length: {
          title: 'There is a problem with the Day',
          message: 'For the **from** date, there are not that many days in this month.',
          note: '',
        },
        min: {
          title: 'There is a problem with the Day',
          message: 'For the **from** date, there are not that many days in this month.',
          note: '',
        },
        max: {
          title: 'There is a problem with the Day',
          message: 'For the **from** date, there are not that many days in this month.',
          note: '',
        },
      },
      year: {
        max: {
          title: 'There is a problem with the Year',
          message: "For the **from** date, the year can't be in the future.",
          note: '',
        },
        min: {
          title: 'There is a problem with the Year',
          message: 'For the **from** date, this year is too far in the past.',
          note: '',
        },
      },
      max: {
        title: 'There is a problem with the date',
        message: "For the **from** date, the date can't be in the future.",
      },
      min: {
        title: 'There is a problem with the date',
        message: 'For the **from** date, the date should be after your date of birth.',
      },
      relative: {
        month: {
          notfound: {
            title: 'There is a problem with the Month',
            message:
              'For the **from** date, the month should be between 1(January) and 12(December).',
            note: '',
          },
          min: {
            title: 'There is a problem with the Month',
            message:
              'For the **from** date, the month should be between 1(January) and 12(December).',
            note: '',
          },
          max: {
            title: 'There is a problem with the Month',
            message:
              'For the **from** date, the month should be between 1(January) and 12(December).',
            note: '',
          },
        },
        day: {
          length: {
            title: 'There is a problem with the Day',
            message: 'For the **from** date, there are not that many days in this month.',
            note: '',
          },
          min: {
            title: 'There is a problem with the Day',
            message: 'For the **from** date, there are not that many days in this month.',
            note: '',
          },
          max: {
            title: 'There is a problem with the Day',
            message: 'For the **from** date, there are not that many days in this month.',
            note: '',
          },
        },
        year: {
          max: {
            title: 'There is a problem with the Year',
            message: "For the **from** date, the year can't be in the future.",
            note: '',
          },
          min: {
            title: 'There is a problem with the Year',
            message: 'For the **from** date, this year is too far in the past.',
            note: '',
          },
        },
        max: {
          title: 'There is a problem with the date',
          message: "For the **from** date, the date can't be in the future.",
        },
        min: {
          title: 'There is a problem with the date',
          message: "For the **from** date, the date should be after this person's date of birth.",
        },
      },
      cohabitant: {
        month: {
          notfound: {
            title: 'There is a problem with the Month',
            message:
              'For the **from** date, the month should be between 1(January) and 12(December).',
            note: '',
          },
          min: {
            title: 'There is a problem with the Month',
            message:
              'For the **from** date, the month should be between 1(January) and 12(December).',
            note: '',
          },
          max: {
            title: 'There is a problem with the Month',
            message:
              'For the **from** date, the month should be between 1(January) and 12(December).',
            note: '',
          },
        },
        day: {
          length: {
            title: 'There is a problem with the Day',
            message: 'For the **from** date, there are not that many days in this month.',
            note: '',
          },
          min: {
            title: 'There is a problem with the Day',
            message: 'For the **from** date, there are not that many days in this month.',
            note: '',
          },
          max: {
            title: 'There is a problem with the Day',
            message: 'For the **from** date, there are not that many days in this month.',
            note: '',
          },
        },
        year: {
          max: {
            title: 'There is a problem with the Year',
            message: "For the **from** date, the year can't be in the future.",
            note: '',
          },
          min: {
            title: 'There is a problem with the Year',
            message: 'For the **from** date, this year is too far in the past.',
            note: '',
          },
        },
        max: {
          title: 'There is a problem with the date',
          message: "For the **from** date, the date can't be in the future.",
        },
        min: {
          title: 'There is a problem with the date',
          message: "For the **from** date, the date should be after this person's date of birth.",
        },
      },
      civilunion: {
        month: {
          notfound: {
            title: 'There is a problem with the Month',
            message:
              'For the **from** date, the month should be between 1(January) and 12(December).',
            note: '',
          },
          min: {
            title: 'There is a problem with the Month',
            message:
              'For the **from** date, the month should be between 1(January) and 12(December).',
            note: '',
          },
          max: {
            title: 'There is a problem with the Month',
            message:
              'For the **from** date, the month should be between 1(January) and 12(December).',
            note: '',
          },
        },
        day: {
          length: {
            title: 'There is a problem with the Day',
            message: 'For the **from** date, there are not that many days in this month.',
            note: '',
          },
          min: {
            title: 'There is a problem with the Day',
            message: 'For the **from** date, there are not that many days in this month.',
            note: '',
          },
          max: {
            title: 'There is a problem with the Day',
            message: 'For the **from** date, there are not that many days in this month.',
            note: '',
          },
        },
        year: {
          max: {
            title: 'There is a problem with the Year',
            message: "For the **from** date, the year can't be in the future.",
            note: '',
          },
          min: {
            title: 'There is a problem with the Year',
            message: 'For the **from** date, this year is too far in the past.',
            note: '',
          },
        },
        max: {
          title: 'There is a problem with the date',
          message: "For the **from** date, the date can't be in the future.",
        },
        min: {
          title: 'There is a problem with the date',
          message: "For the **from** date, the date should be after this person's date of birth.",
        },
      },
      foreignNationalSponsorship: {
        max: {
          title: 'There is a problem with your entry',
          message: "For the **from** date, the date can't be in the future.",
        },
        min: {
          title: 'There is a problem with your entry',
          message: 'For the **from** date, the date should be after their date of birth.',
        },
        required: {
          title: 'Your response is required',
          message: '',
        },
      },
    },
    order: {
      title: 'There is a problem with the date range',
      message: 'The **from** date should be before the **to** date.',
      note: '',
    },
    required: {
      title: 'Your response is required',
      message: 'All parts of the date(s) are required even if it is **estimated**.',
    },
    invalid: {
      title: 'There is a problem',
      message: 'The dates you selected are invalid.',
    },
  },
  weight: {
    pattern: {
      title: 'Invalid format',
      message: 'Please use numbers only',
      note: '',
    },
    min: {
      title: 'Weight below accepted limits',
      message: 'We only accept a value between 10 and 999 pounds',
      note: '',
    },
    max: {
      title: 'Weight exceeds accepted limits',
      message: 'We only accept a value between 10 and 999 pounds',
      note: '',
    },
    required: {
      title: 'Your response is required',
      message: '',
    },
  },
  height: {
    feet: {
      pattern: {
        title: 'Invalid format',
        message: 'Please use numbers only',
        note: '',
      },
      min: {
        title: 'Feet is under the accepted limits',
        message: 'Feet must be between 1 and 9',
        note: '',
      },
      max: {
        title: 'Feet is above the accepted limits',
        message: 'Feet must be between 1 and 9',
        note: '',
      },
    },
    inches: {
      pattern: {
        title: 'Invalid format',
        message: 'Please use numbers only',
        note: '',
      },
      min: {
        title: 'Inches is below the accepted limits',
        message: 'Inches must be between 0 and 11',
        note: '',
      },
      max: {
        title: 'Inches is above the accepted limits',
        message: 'Inches must be between 0 and 11',
        note: '',
      },
    },
    required: {
      title: 'Your response is required',
      message: '',
    },
  },
  location: {
    required: {
      title: 'Your response is required',
      message: '',
    },
    street: {
      required: {
        title: 'Your response is required',
        message: '',
      },
      poBox: {
        pattern: {
          title: 'There is a problem with the Street Address',
          message: 'Addresses that include a Post Office Box are not accepted.',
          note: 'Note: Do not use a post office box as an address.',
        },
      },
    },
    state: {
      required: {
        title: 'Your response is required',
        message: '',
      },
      notfound: {
        title: 'There is a problem with the State',
        message: [
          'State name must be one of the available options.',
          '*and/or*',
          'The state name is too long.',
        ],
        note: '',
      },
    },
    city: {
      required: {
        title: 'Your response is required',
        message: '',
      },
      pattern: {
        title: 'There is a problem with the City',
        message: 'City name has invalid characters.',
        note: '',
      },
      length: {
        title: 'There is a problem with the City',
        message: 'City name should be between 2 and 100 characters.',
        note: '',
      },
    },
    zipcode: {
      required: {
        title: 'Your response is required',
        message: '',
      },
      pattern: {
        title: 'There is a problem with the ZIP Code',
        message: 'The ZIP Code should be either 5 or 9 digits.',
        note: '',
      },
    },
    toggleablelocation: {
      required: {
        title: 'Your response is required',
        message: '',
      },
      city: {
        length: {
          title: 'There is a problem with the City',
          message: 'City name should be between 2 and 100 characters.',
          note: '',
        },
        pattern: {
          title: 'There is a problem with the City',
          message: 'City name has invalid characters.',
          note: '',
        },
        required: {
          title: 'There is a problem with the City',
          message: 'City is required if County is not filled in',
          note: '',
        },
      },
      state: {
        notfound: {
          title: 'There is a problem with the State',
          message: [
            'State name must be one of the available options.',
            '*and/or*',
            'The state name is too long.',
          ],
          note: '',
        },
      },
      county: {
        length: {
          title: 'There is a problem with the County',
          message: 'County name must be between 2 and 100 characters',
          note: '',
        },
        required: {
          title: 'There is a problem with the County',
          message: 'County is required if City is not filled in',
          note: '',
        },
      },
      zipcode: {
        pattern: {
          title: 'There is a problem with the ZIP Code',
          message: 'The ZIP Code should be either 5 or 9 digits.',
          note: '',
        },
        status: {
          title: 'There is a problem with the ZIP Code',
          message: 'The ZIP Code must be from the state in the address.',
          note: 'Note: Please make sure you also entered the correct state code.',
        },
      },
      country: {
        required: {
          title: 'Your response is required',
          message: '',
        },
        notfound: {
          title: 'This country is not on our current list',
          message: [
            "If you don't see your country in the list, select the country that presently governs the location you are referring to.",
          ],
          note: '',
        },
      },
      apofpo: {
        notfound: {
          title: 'There is a problem with the State Code',
          message: 'APO/FPO state code must be 2 letters',
          note: 'Note: Typically the value is either AA, AE, or AP.',
        },
      },
    },
    address: {
      required: {
        title: 'Your response is required',
        message: '',
      },
      city: {
        length: {
          title: 'There is a problem with the City',
          message: 'City name should be between 2 and 100 characters.',
          note: '',
        },
        pattern: {
          title: 'There is a problem with the City',
          message: 'City name has invalid characters.',
          note: '',
        },
      },
      state: {
        notfound: {
          title: 'There is a problem with the State',
          message: [
            'State name must be one of the available options.',
            '*and/or*',
            'The state name is too long.',
          ],
          note: '',
        },
      },
      county: {
        length: {
          title: 'There is a problem with the County',
          message: 'County name must be between 2 and 100 characters',
          note: '',
        },
      },
      zipcode: {
        pattern: {
          title: 'There is a problem with the ZIP Code',
          message: 'The ZIP Code should be either 5 or 9 digits.',
          note: 'Note: A 9 digit zip code should be in the following format #####-####.',
        },
        status: {
          title: 'There is a problem with the ZIP Code',
          message: 'The ZIP Code must be from the state in the address.',
          note: 'Note: Please make sure you also entered the correct state code.',
        },
      },
      country: {
        notfound: {
          title: 'This country is not on our current list',
          message: [
            "If you don't see your country in the list, select the country that presently governs the location you are referring to.",
          ],
          note: '',
        },
      },
      apofpo: {
        notfound: {
          title: 'There is a problem with the State Code',
          message: 'APO/FPO state code must be 2 letters',
          note: 'Note: Typically the value is either AA, AE, or AP.',
        },
      },
      street: {
        poBox: {
          pattern: {
            title: 'There is a problem with the Street Address',
            message: 'Addresses that include a Post Office Box are not accepted.',
            note: 'Note: Do not use a post office box as an address.',
          },
        },
      },
    },
  },
  city: {
    length: {
      title: 'There is a problem with the City',
      message: 'City name should be between 2 and 100 characters.',
      note: '',
    },
    pattern: {
      title: 'There is a problem with the City',
      message: 'City name has invalid characters.',
      note: '',
    },
    apofporequired: {
      title: 'APO or FPO Selection Required',
      message: 'You must select either APO or FPO for your address below.',
    },
  },
  state: {
    notfound: {
      title: 'There is a problem with the State',
      message: [
        'State name must be one of the available options.',
        '*and/or*',
        'The state name is too long.',
      ],
      note: '',
    },
  },
  county: {
    length: {
      title: 'There is a problem with the County',
      message: 'County name must be between 2 and 100 characters',
      note: '',
    },
    missing: {
      title: 'There is a problem with the County',
      message: 'County or County equivalent is required',
    },
  },
  zipcode: {
    pattern: {
      title: 'There is a problem with the ZIP Code',
      message: 'The ZIP Code should be either 5 or 9 digits.',
      note: '',
    },
    state: {
      title: 'There is a problem with the ZIP Code',
      message: 'The Zip Code must be a valid APO, FPO, or DPO zip code.',
    },
  },
  country: {
    required: {
      title: 'Your response is required',
      message: '',
    },
    pomissing: {
      title: 'Country is invalid',
      message: 'Edit the address or click in and out of one of the fields below to resolve this error.',
    },
    notfound: {
      title: 'This Country is not on our current list',
      message: [
        "If you don't see your country in the list, select the country that presently governs the location you are referring to.",
      ],
      note: '',
    },
    ponotallowed: {
      title: 'Post Office addresses are not allowed here',
      message: [
        "An APO/FPO address is currently selected, which is not allowed here. You must select either of the 'In the U.S.' or 'Outside the U.S.' radio buttons below.",
      ],
    },
    duplicate: {
      title: 'This entry is a duplicate of another you have already entered',
      message: [
        'This entry indicates you had two citizenships with the same country at the same time as another entry in this list. Please check the other entry items on this page for duplicate entries and make corrections as needed.',
      ],
    },
  },
  citizenship: {
    duplicate: {
      title: 'Duplicate Country',
      message: [
        'Please remove any duplicate countries.',
      ],
    },
  },
  passport: {
    length: {
      title: 'There is a problem with the passport number',
      message: [
        'U.S. Passport numbers must be nine alphanumeric characters (letters and numbers).',
      ],
      note: '',
    },
    required: {
      title: 'Your response is required',
      message: '',
    },
    pattern: {
      title: 'There is a problem with the passport number',
      message: [
        'U.S. Passport numbers must be nine alphanumeric characters (letters and numbers).',
      ],
      note: '',
    },
    expiration: {
      min: {
        title: 'There is a problem with the date',
        message: 'The date should be after the passport was issued.',
      },
      max: {
        title: 'There is a problem with the date',
        message: 'The expiration date should be no more than 10 years after the passport was issued.',
      },
    },
  },
  currency: {
    max: {
      title: 'Currency value is too large',
      message: 'Currency amounts over $2,147,483,647 are not supported.',
    },
    min: {
      title: 'There is a problem with the losses',
      message: 'The reported losses should have a dollar value.',
      note: '',
    },
    notInteger: {
      title: 'There is a problem with the number',
      message: 'The reported amount should have a whole dollar value, not decimal or text.',
      note: '',
    },
    required: {
      title: 'Your response is required',
      message: '',
    },
  },
  telephone: {
    pattern: {
      title: 'There is a problem with the phone number.',
      message: 'The phone number format is not valid.',
      note: '',
    },
    duplicate: {
      title: 'There is a problem with the phone number.',
      message: 'You cannot have duplicate phone numbers.',
      note: '',
    },
    domestic: {
      first: {
        pattern: {
          title: 'There is a problem with the area code',
          message:
            'The area code should be 3 numbers long, between 0 and 9, and cannot begin with 0.',
          note: '',
        },
        length: {
          title: 'There is a problem with the area code',
          message:
            'The area code should be 3 numbers long, between 0 and 9, and cannot begin with 0.',
          note: '',
        },
        required: {
          title: 'Your response is required',
          message: '',
        },
      },
      second: {
        pattern: {
          title: 'There is a problem with the phone number',
          message:
            'The first part of the phone number should be 3 numbers long and between 0 and 9.',
          note: '',
        },
        length: {
          title: 'There is a problem with the phone number',
          message:
            'The first part of the phone number should be 3 numbers long and between 0 and 9.',
          note: '',
        },
        required: {
          title: 'Your response is required',
          message: '',
        },
      },
      third: {
        pattern: {
          title: 'There is a problem with the phone number',
          message:
            'The last part of the phone number should be 4 numbers long and between 0 and 9.',
          note: '',
        },
        length: {
          title: 'There is a problem with the phone number',
          message:
            'The last part of the phone number should be 4 numbers long and between 0 and 9.',
          note: '',
        },
        required: {
          title: 'Your response is required',
          message: '',
        },
      },
      extension: {
        pattern: {
          title: 'There is a problem with the extension',
          message: 'Extensions should be between 0 and 10.',
          note: '',
        },
        length: {
          title: 'There is a problem with the extension',
          message: 'Extensions should be between 0 and 10.',
          note: '',
        },
      },
    },
    international: {
      first: {
        pattern: {
          title: 'There is a problem with this number',
          message: 'The international number should be 4-20 digits between 0 and 9.',
          note: '',
        },
        length: {
          title: 'There is a problem with this number',
          message: 'The international number should be 4-20 digits between 0 and 9.',
          note: '',
        },
        required: {
          title: 'Your response is required',
          message: '',
        },
      },
    },
    numberType: {
      required: {
        title: 'Your response is required',
        message: '',
      },
    },
  },
  geocode: {
    original: {
      title: 'Original address',
    },
    partial: {
      title: 'Alternate address found',
      label: 'Suggested Address',
      para:
        'Consider the highlighted change below. Using the US Postal Service suggested address will help us process your case more quickly.',
    },
    city: {
      title: 'City could not be found',
      para: 'There is a city-state mismatch. Have you entered the correct city and state?',
    },
    notfound: {
      title: 'Address not found',
      para:
        'Looks like USPS couldn\'t validate the address you entered. Please check your address and try again. If your address is correct please continue without verification from USPS.',
    },
    generic: {
      title: 'Unable to validate address',
      para: 'The address provided cannot be properly validated.',
    },
    multiple: {
      title: 'Multiple address found',
      para: 'Multiple addresses were found for the information you entered, and no default exists.',
    },
    defaultAddress: {
      title: 'More information required',
      para:
        'The address you entered was found but more information is needed (such as an apartment, suite, or box number) to match to a specific address.',
    },
    system: {
      title: 'Error communicating with USPS service',
      para:
        'We are currently not able to communicate with USPS address validation, please try again later.',
      xml: {
        title: 'Error communicating with USPS service',
        para:
          'We are currently not able to communicate with USPS address validation, please try again later.',
      },
    },
  },
  email: {
    pattern: {
      title: "This email isn't valid",
      message: 'Check for any spelling and/or format mistakes in your email address.',
      note: 'Example of valid email format: name@domain.com',
    },
    required: {
      title: 'Your response is required',
      message: '',
    },
  },
  treatment: {
    began: {
      max: {
        title: 'There is a problem with the date',
        message: "The date can't be in the future.",
      },
      min: {
        title: 'There is a problem with the date',
        message: 'The date should be after your date of birth.',
      },
    },
    end: {
      max: {
        title: 'There is a problem with the date',
        message: "The date can't be in the future.",
      },
      min: {
        title: 'There is a problem with the date',
        message: 'The date should be after the date treatment began.',
      },
    },
    items: {
      minLength: {
        title: 'There is a problem with the treatment data',
        message: 'There must be at least one treatment listed.',
      },
    },
  },
  diagnosis: {
    explanation: {
      title: 'There is a problem with the explanation',
      message: 'Please fully explain the effectiveness of your treatment.',
    },
  },
  contact: {
    last: {
      max: {
        title: 'There is a problem with the date',
        message: "The date can't be in the future.",
      },
      min: {
        title: 'There is a problem with the date',
        message: 'The date should be after the first contact.',
      },
    },
  },
  parent: {
    dob: {
      max: {
        title: 'There is a problem with the date',
        message: "The date can't be in the future and must be before your date of birth.",
      },
      min: {
        title: 'There is a problem with the date',
        message: 'The age may not exceed 200 years.',
      },
    },
  },
  child: {
    dob: {
      max: {
        title: 'There is a problem with the date',
        message: "The date can't be in the future and must be after your date of birth.",
      },
      min: {
        title: 'There is a problem with the date',
        message: 'The date must be after your date of birth.',
      },
    },
  },
  dob: {
    max: {
      title: 'There is a problem with the date',
      message: "The date can't be in the future.",
    },
    min: {
      title: 'There is a problem with the date',
      message: 'The age may not exceed 200 years.',
    },
  },
  required: {
    title: 'Your response is required',
    message: '',
  },
  length: {
    title: 'Your response is greater than the allowed max length',
    message: '',
  },
  submission: {
    message:
      'There was a problem submitting your {{formName}}. Please contact support for additional information. You may reach support via phone at (878) 274-5091 between the available hours of 0600 and 1700 Eastern Standard Time (EST), or by email at DCSAAKC@mail.mil.',
  },
  submissionErrorCode: {
    message:
      'Error Code: {{errorCode}} -- {{errorTime}}',
  },
  submissionErrorBody: {
    message:
      'Details: {{errorBody}}',
  },
  submissionCommunication: {
    message:
      'A communication error has occurred and the system cannot submit your application at this time. This is often temporary and can be resolved by trying again later.',
  },
  invalidMaritalRelationInlaws: {
    title: 'There is a problem with your selected marital status.',
    message: 'You cannot have an "in-law" as a relative type if you have never been married. If you have already removed all "in-law" relative types, please deselect and reselect this option to remove this error.',
  },
  invalidSeparatedStatusSelection: {
    title: 'There is a problem with your selected marital status.',
    message: "'Yes' must be selected if Marital Status is 'Separated'",
  },
  validMaritalRelation: {
    title: 'Mother-in-law and father-in-law must be provided',
    message:
      'You indicated that you are married or separated, please provide entries for mother-in-law and father-in-law.',
  },
  validMaritalRelationWarning: {
    title: 'Information for mother-in-law and father-in-law must be provided',
    message:
      'If you do not know your mother and/or father in-law, please enter as much information as possible for the required fields.',
  },
  validRelation: {
    title: 'Mother and father must be provided',
    message:
      'If you do not know your mother or father, please enter "I don\'t know" and provide a comment explaining your relationship.',
  },
  validRelationWarning: {
    title: 'Information for mother and father must be provided',
    message:
      'If you do not know your mother and/or father, please enter as much information as possible for the required fields.',
  },
  validPhoneTypes: {
    title: 'There is a problem with your phone numbers',
    message: 'Please provide only one of each phone number type.',
  },
  civilUnion: {
    min: {
      title: 'There is a problem with the date',
      message: 'This date is before either you or your partner was born.',
    },
    max: {
      title: 'There is a problem with the date',
      message: "The date can't be in the future.",
    },
    required: {
      title: 'Your response is required',
      message: '',
    },
  },
  divorceDate: {
    min: {
      title: 'There is a problem with the date',
      message:
        'This date is before the date your civil marriage, civil union, or domestic partnership was legally recognized',
    },
    max: {
      title: 'There is a problem with the date',
      message: "The date can't be in the future.",
    },
    required: {
      title: 'Your response is required',
      message: '',
    },
  },
  dateSeparated: {
    min: {
      title: 'There is a problem with the date',
      message:
        'This date is before the date your civil marriage, civil union, or domestic partnership was legally recognized',
    },
  },
  cohabitant: {
    min: {
      title: 'There is a problem with the date',
      message: 'This date is before your cohabitant was born.',
    },
    max: {
      title: 'There is a problem with the date',
      message: "The date can't be in the future.",
    },
    applicantmin: {
      title: 'There is a problem with the date',
      message: 'This date is before you were born.',
    },
    required: {
      title: 'Your response is required',
      message: '',
    },
  },
  marital: {
    min: {
      title: 'There is a problem with the date',
      message: 'This date is before individual was born.',
    },
    max: {
      title: 'There is a problem with the date',
      message: "The date can't be in the future.",
    },
    required: {
      title: 'Your response is required',
      message: '',
    },
  },
  foreignBirthdate: {
    min: {
      title: 'There is a problem with the date',
      message: 'This date is too early.',
    },
    max: {
      title: 'There is a problem with the date',
      message: "The date can't be in the future.",
    },
    required: {
      title: 'Your response is required',
      message: '',
    },
  },
  foreignContact: {
    min: {
      title: 'There is a problem with the date',
      message: 'This date is before either you or your foriegn contact was born.',
    },
    max: {
      title: 'There is a problem with the date',
      message: "The date can't be in the future.",
    },
    required: {
      title: 'Your response is required',
      message: '',
    },
  },
  futureBenefit: {
    min: {
      title: 'There is a problem with the date',
      message: 'The date must be in the future.',
    },
    required: {
      title: 'Your response is required',
      message: '',
    },
  },
  validMinimumCitizenships: {
    title: 'There is a problem with your entry',
    message: 'Please provide a minimum of two countries.',
  },
  alphanumeric: {
    required: {
      title: 'Your response is required',
      message: '',
    },
    pattern: {
      title: 'There is a problem with your entry',
      message: 'Only use letters and numbers.',
    },
    patternExceptOnlyZero: {
      title: 'There is a problem with your entry',
      message: 'Only use letters and numbers. Cannot be only 0.',
    },
  },
  nonPayment: {
    required: {
      title: 'Your response is required',
      message: '',
    },
    max: {
      title: 'There is a problem with your entry',
      message: "The date can't be in the future",
    },
    min: {
      title: 'There is a problem with your entry',
      message: 'The date resolved is before the financial issue began.',
    },
    accountNumber: {
      pattern: {
        title: 'There is a problem with the Loan/Account Number',
        message: 'Please use alphanumeric characters and dashes/periods/commas/spaces only.',
        note: '',
      },
    }
  },
  taxesSatisfied: {
    required: {
      title: 'Your response is required',
      message: '',
    },
    min: {
      title: 'There is a problem with your entry',
      message: 'The date satisfied is before the date you failed to file or pay.',
    },
    max: {
      title: 'There is a problem with your entry',
      message: 'The date satisfied cannot be in the future.',
    },
  },
  drugUsage: {
    required: {
      title: 'Your response is required',
      message: '',
    },
    min: {
      title: 'There is a problem with your entry',
      message: 'The date of most recent use is before the date of first use.',
    },
    max: {
      title: 'There is a problem with the date',
      message: "The date can't be in the future.",
    },
  },
  alcohol: {
    negativeImpact: {
      occurred: {
        error: {
          tooEarly: {
            title: 'There is a problem with the date.',
            message:
              'The date must be after the initial date of involvement or use, specified below.',
          },
          tooLate: {
            title: 'There is a problem with the date.',
            message:
              'The date must be before the final date of involvement or use, specified below.',
          },
        },
      },
    },
  },
  passportInformation: {
    required: {
      title: 'Your response is required',
      message: '',
    },
    min: {
      title: 'There is a problem with your entry',
      message: 'The date of of expiration is before the date of issue.',
    },
  },
  directControl: {
    required: {
      title: 'Your response is required',
      message: '',
    },
    min: {
      title: 'There is a problem with your entry',
      message: 'The date relinquished is before the date acquired.',
    },
    max: {
      title: 'There is a problem with the date',
      message: "The date can't be in the future.",
    },
  },
  indirectControl: {
    required: {
      title: 'Your response is required',
      message: '',
    },
    min: {
      title: 'There is a problem with your entry',
      message: 'The date sold, lost or otherwise disposed of is before the date acquired.',
    },
    // TODO: When 4733 is done, remove the below.
    max: {
      title: 'There is a problem with your entry',
      message: "The date can't be in the future.",
    },
  },
  bankruptcy: {
    required: {
      title: 'Your response is required',
      message: '',
    },
    min: {
      title: 'There is a problem with your entry',
      message: 'The date of discharge of is before the date filed.',
    },
    max: {
      title: 'There is a problem with your entry',
      message: 'The date of discharge cannot be in the future.',
    },
  },
  delinquent: {
    required: {
      title: 'Your response is required',
      message: '',
    },
    min: {
      title: 'There is a problem with your entry',
      message: 'The date the issue was resolved is before the date the issue began.',
    },
    max: {
      title: 'There is a problem with your entry',
      message: 'The date the issue was resolved cannot be in the future.',
    },
    accountNumber: {
      pattern: {
        title: 'There is a problem with the Loan/Account Number',
        message: 'Please use alphanumeric characters and dashes/periods/commas/spaces only.',
        note: '',
      },
    }
  },
  drugPurchase: {
    required: {
      title: 'Your response is required',
      message: '',
    },
    min: {
      title: 'There is a problem with your entry',
      message: 'The date of most recent involvement is before the date of first involvement.',
    },
    max: {
      title: 'There is a problem with your entry',
      message: 'The date of most recent involvement cannot be in the future.',
    },
  },
  clearanceGranted: {
    required: {
      title: 'Your response is required',
      message: '',
    },
    min: {
      title: 'There is a problem with your entry',
      message:
        'The date of clearance eligibility/access was granted is before the date investigation was completed.',
    },
    max: {
      title: 'There is a problem with your entry',
      message: 'The date of clearance eligibility/access was granted cannot be in the future.',
    },
  },
  courtDate: {
    required: {
      title: 'Your response is required',
      message: '',
    },
    min: {
      title: 'There is a problem with your entry',
      message: 'The date of charge is before the date of the offense.',
    },
    max: {
      title: 'There is a problem with your entry',
      message: 'The date of charge cannot be in the future.',
    },
  },
  beforeOffense: {
    title: 'There is a problem with your entry',
    message: 'This date is before the date of the offense.',
  },
  enterOffenseDate: {
    title: 'There is problem with your entry',
    message: 'You must enter a date for the date of offense'
  },
  enterConvictionDate: {
    title: 'There is problem with your entry',
    message: 'You must enter a date for the date of conviction'
  },
  beforeConvicted: {
    title: 'There is a problem with your entry',
    message: 'This date is before the date of conviction.',
  },
  occurred: {
    required: {
      title: 'Your response is required',
      message: '',
    },
    min: {
      title: 'There is a problem with your entry',
      message: 'The date of negative impact is before the dates of involvement or use.',
    },
    max: {
      title: 'There is a problem with your entry',
      message: 'The date of negative impact is after the dates of involvement or use.',
    },
  },
  relativeLastContact: {
    title: 'There is a problem with the date',
    message: 'This date is before the date of first contact.',
  },
  relativeRequirements: {
    title: 'Missing required relatives',
    message: 'You must list a mother and father. If your marital status is currently in a civil marriage, legally recognized civil union, or legally recognized domestic partnership, or separated, you must list a mother in law and father in law.',
  },
  relationship: {
    length: {
      min: {
        title: 'Missing selection',
        message: 'Please select a value.',
      },
    },
  },
  birthdateTooFar: {
    min: {
      title: 'There is a problem with the date',
      message: 'This date is too far in the past.',
    },
  },
  military: {
    serviceNumber: {
      pattern: {
        title: 'There is a problem with the Service Number',
        message: 'Please use numbers, letters, and dashes only.',
      },
    },
    selective: {
      registrationNumber: {
        pattern: {
          title: 'There is a problem with the Registration Number',
          message: 'Please use numbers and dashes only.',
          note: '',
        },
      },
      serviceNumber: {
        pattern: {
          title: 'There is a problem with the Service Number',
          message: 'Please use numbers and dashes only.',
          note: '',
        },
      },
    },
  },
  education: {
    diplomas: {
      date: {
        tooEarly: {
          title: 'There is a problem with the date',
          message: 'The date that your degree/diploma was awarded cannot be before your date of enrollment.',
        },
      },
    },
  },
  durationCoverage: {
    presentUnchecked: {
      title: 'There is a problem with the date coverage.',
      message: 'You need to have at least one "present" checkbox selected.',
    }
  },
  pvq: {
    installationName: {
      length: {
        message: 'Installation name should be between 2 and 100 characters.',
        note: '',
        title: 'There is a problem with the installation name',
      },
      pattern: {
        message: 'Installation name has invalid characters.',
        note: '',
        title: 'There is a problem with the installation name',
      },
    },
    zipcode: {
      pattern: {
        title: 'There is a problem with the ZIP Code',
        message: 'The ZIP Code should be either 5 or 9 digits.',
        note: '',
      },
      state: {
        title: 'There is a problem with the ZIP Code',
        message: 'The Zip Code must be a valid APO, FPO, or DPO zip code.',
      },
    },
    name: {
      last: {
        required: {
          title: 'Oops, there\'s a problem.',
          message: 'The last name must be provided.',
          note: '',
        },
        length: {
          title: 'Oops, there\'s a problem.',
          message: 'Entry must be between 2 - 100 characters',
          note: '',
        },
        pattern: {
          title: 'There is a problem with the last name',
          message: "Some of these characters aren't allowed.",
          note: "Only use letters, hyphens (-), periods (.), apostrophes ('), and spaces.",
        },
        dataIntegrity: {
          checkedWithValue: {
            title: 'Oops, there\'s a problem.',
            message:
            "Conflicting data found. Please correct by unselecting 'No First Name' or clearing First Name field",
            note: '',
          },
          aliasOrNickname: {
            title: 'Oops, there\'s a problem.',
            message:
            "For nicknames and aliases, put them in the 'First Name' block and leave the 'Last Name' and 'Middle Name' blocks blank",
            note: '',
          }
        },
      },
      first: {
        required: {
          title: 'Oops, there\'s a problem.',
          message:
          'The first name must be provided',
          note: '',
        },
        length: {
          title: 'Oops, there\'s a problem.',
          message:
          'Issue with the length of entry',
          note: '',
          tooshort: {
            title: 'Oops, there\'s a problem.',
            message:
            'You have not entered the minimum number of characters for this field.',
            note: '',
          },
          toolong: {
            title: 'Oops, there\'s a problem.',
            message:
            'Entry must not exceed 100 characters',
            note: '',
          },
        },
        pattern: {
          title: 'There is a problem with the first name',
          message: "Some of these characters aren't allowed.",
          note: "Only use letters, hyphens (-), periods (.), apostrophes ('), and spaces.",
        },
        dataIntegrity: {
          checkedWithValue: {
            title: 'Oops, there\'s a problem.',
            message:
            "Conflicting data found. Please correct by unselecting 'No First Name' or clearing First Name field",
            note: '',
          },
        },
      },
      middle: {
        required: {
          title: 'Oops, there\'s a problem.',
          message:
          'The middle name must be provided',
          note: '',
        },
        length: {
          title: 'Oops, there\'s a problem.',
          message:
          'Issue with the length of entry',
          note: '',
          empty: {
            title: 'Oops, there\'s a problem.',
            message: 'Middle name must be empty',
            note: '',
          },
          tooshort: {
            title: 'Oops, there\'s a problem.',
            message:
            'You have not entered the minimum number of characters for this field.',
            note: '',
          },
          toolong: {
            title: 'Oops, there\'s a problem.',
            message:
            'Entry must not exceed 100 characters',
            note: '',
          },
        },
        pattern: {
          title: 'There is a problem with the middle name',
          message: "Some of these characters aren't allowed.",
          note: "Only use letters, hyphens (-), periods (.), apostrophes ('), and spaces.",
        },
        dataIntegrity: {
          checkedWithValue: {
            title: 'Oops, there\'s a problem.',
            message:
            "Conflicting data found. Please correct by unselecting 'No Middle Name' or clearing Middle Name field",
            note: '',
          },
        },
      },
      length: {
        title: 'Oops, there\'s a problem.',
        message: '',
        note: '',
        tooshort: {
          title: 'Oops, there\'s a problem.',
          message: 'At least one letter required.',
          note: '',
        },
        toolong: {
          title: 'Oops, there\'s a problem.',
          message: 'Only up to 100 characters allowed.',
          note: '',
        },
      },
      pattern: {
        title: 'There is a problem with the first name',
        message: "Some of these characters aren't allowed.",
        note: "Only use letters, hyphens (-), periods (.), apostrophes ('), and spaces.",
      },
      lettersonly: {
        length: {
          title: 'Oops, there\'s a problem.',
          message: 'Entry needs to be between 1 - 100 characters',
          note: '',
        },
        pattern: {
          title: 'Oops, there\'s a problem.',
          message: "Some of these characters aren't allowed.",
          note: "Only use letters, hyphens (-), periods (.), apostrophes ('), and commas (,) and spaces.",
        },
      },
      dataIntegrity: {
        checkedWithValue: {
          title: 'Oops, there\'s a problem.',
          message:
            "Conflicting data found. Please correct by unselecting 'No First Name' or clearing First Name field",
          note: '',
        },
      },
    },
    suffix: {
      required: {
        title: 'Your response is required',
        message: '',
        note: '',
      },
      inclusion: {
        title: 'The selected option does not exist',
        message: '',
        note: '',
      },
    },
    suffixOther: {
      pattern: {
        title: 'There is a problem with the name suffix',
        message: "Some of these characters aren't allowed.",
        note: "Only use letters, hyphens (-), periods (.), apostrophes ('), and commas (,) and spaces.",
      },
      length: {
        toolong: {
          title: 'Oops, there\'s a problem.',
          message:
            'The suffix is too long',
          note: '',
        },
      },
    },
    duplicate: {
      alias: {
        title: 'Oops, there\'s a problem.',
        message: 'This alias is a duplicate of another alias, correct or remove the duplicate.',
        note: '',
      },
    },
    required: {
      title: 'Your response is required',
      message: '',
      note: '',
    },
  },
};
